import React from 'react';
import { INITIAL_SUGGESTIONS_URL,MS_LOCATION } from '../../constants/constants';
import '../../assets/css/search.css';
import Suggestions from './Suggestions';

export default class Search extends React.Component {

    constructor(props) {
        super(props);
        this.autoCompleteRef = React.createRef();
        this.inputRef = React.createRef();
        this.state = {
        // searchURL: "https://www.verizon.com/onesearch/search?q=call&ES=ResidentialSupport&src=home",
        // query: '',
            results: [],
            homequicklinks:[]
        // defaultLinks: []
        };
        this.setWrapperRef = this.setWrapperRef.bind(this);
        this.handleSearchClickOutside = this.handleSearchClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleSearchClickOutside);

    let config = {
        source: "SUPPORT",           
        targetEl: "oneSearchContainer",  
        inCommunity: true,
        inSupport: true,       
        showRecentSearches: true,
        showSupportArticles: true,
        ES:"SUPPORT",          
      }
      window.renderAutoSuggest(config);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleSearchClickOutside);
  }

  setWrapperRef(node) {
    this.wrapperRef = node;
  }

  handleSearchClickOutside(event) {
    if (this.wrapperRef && !this.wrapperRef.contains(event.target)) {
        this.autoCompleteRef.current.parentElement.classList.remove('focused');
    }
  }

  componentWillUnmount() {
    }
    
    onSearchBoxFocus(e) {
        //window.scLinkTrackID11('support_search');
        let domain = window.location.origin.indexOf("www.verizon.com") > -1 ? "https://www.verizon.com" : "https://www98.verizon.com";
        if (this.inputRef.current.value.length <= 2) {
            const localInstance = this;
            if (this.inputRef.current.value.length <= 2) {
                this.inputRef.current.parentElement.parentElement.classList.remove('auto_suggestions');
            }
            // fetch(domain + "/search/AutoSuggest/headersearch/?Ntt=&action=GET_QUICK_LINKS&segments=ResidentialSupport&ES=ResidentialSupport")
            //     .then((response) => {
            //         return response.text();
            //     })
            //     .then((TextContent) => {
            //         localInstance.autoCompleteRef.current.parentElement.classList.add('focused');
            //         localInstance.autoCompleteRef.current.innerHTML = TextContent;
            //     });
            var quicklinksdata =[] ;        
            quicklinksdata = JSON.stringify(window.homePageData.quicklinks[0].quicklinklist);
            var quicklinklist = JSON.parse(quicklinksdata);
            this.setState({
                homequicklinks: quicklinklist
            });
            this.setState({
                results: null
            });
            localInstance.autoCompleteRef.current.parentElement.classList.add('focused');
        } else if(this.inputRef.current.value.length > 2) {
            this.autoCompleteRef.current.parentElement.classList.add('focused');
        }
    }

    onSearchBoxBlur(e) {
        let localInstance = this;
        setTimeout(() => {
            localInstance.autoCompleteRef.current.parentElement.classList.remove('focused');
        }, 200);
       // this.autoCompleteRef.current.innerHTML = '';
    }

    searchValue() {
        //window.scLinkTrackID('search_'+ this.inputRef.current.value);
        this.sendSearchRequest(this.inputRef.current.value);
    }

    sendSearchRequest(searchText) {
        //window.scLinkTrackID('search_'+ searchText);
        if(searchText.length <= 2) {
            this.onSearchBoxFocus(null);
        } else {
            const localInstance = this;
            let autoSuggesturl = null;
            autoSuggesturl = MS_LOCATION + "/getAutoSuggestSearch";
            //autoSuggesturl="https://www.verizon.com/support/consumer/getAutoSuggestSearch";
            const reqData = {"searchText":searchText };

            fetch(autoSuggesturl, {
                method: "POST",
                headers: new Headers({
                    "content-type": "application/json"
                }),
                body: JSON.stringify(reqData)
            }).then(response => response.json())
            .then((data) => {
                let noToRestrict = 0;
                const links = [];
                if(data.typeAheadSummary.TypeAheadSuggestedTerms.length != 0){
                    data.typeAheadSummary.TypeAheadSuggestedTerms.map((result) => {
                        // condition to restrict number of results shown for Autosuggest option
                        if (noToRestrict < 5) {
                            noToRestrict++;
                            const link = {};
                            link.linkurl = result.href.indexOf('/onesearch') > 0 ? (`${result.href}&source=support&flow=support`) : result.href;
                            link.linktext = result.name;
                            links.push(link);
                        }
                    })
                // .catch((error) =>{
                //     console.log(error);
                // });

                this.setState({
                    results: links
                });
                
                this.setState({
                    homequicklinks: null
                });

                localInstance.autoCompleteRef.current.parentElement.classList.add('focused');
                // var quickLinkselement = document.getElementById('quickLinksId');
                // if (typeof(quickLinkselement) != 'undefined' && quickLinkselement != null)
                // {
                //     // Exists.
                //     quickLinkselement.parentNode.removeChild(quickLinkselement);
                // }
            }
            else if(data.typeAheadSummary.TypeAheadSuggestedTerms.length == 0){
                this.setState({
                    results: null
                });
                this.setState({
                    homequicklinks: null
                });
            }
            });
        }
    }

    searchEnteredText(e) {
        //window.scLinkTrackID('search_'+ e.target.value);     
        const keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            if(e.target.value != "")
            {
                let domain = window.location.origin.indexOf("www.verizon.com") > -1 ? "https://www.verizon.com" : "https://www98.verizon.com";
                window.location.href = domain + "/onesearch/search?q=" + e.target.value + "&ES=ResidentialSupport&src=home";
            }
            else{
                alert("Please enter a search phrase");
            }
        } 
        else {
        // if (this.inputRef.current.value.length >= 3) {
                this.inputRef.current.parentElement.parentElement.classList.add('auto_suggestions');
                this.sendSearchRequest(e.target.value);
        // }
        }     
    }

    handleSearchKeyActions(e){
        //Focus trap inside modal overlay - keyboard accessibility fix
       
        var selection = document.querySelector('#auto_suggestdiv') !== null;
        if (selection) {
            const currentfocusedelement = document.activeElement;
            const  focusableElements = '[href], [tabindex]:not([tabindex="-1"])';
            const modal = document.querySelector('#auto_suggestdiv');
            const focusable = modal.querySelectorAll(focusableElements);
            const firstFocusable = focusable[0];
            const lastFocusable = focusable[focusable.length - 1];           
            if (e.ctrlKey || e.altKey) {
                return;
            }

            const keys = {
                9: () => { //9 = TAB
                    if (e.shiftKey && e.target === firstFocusable) {                       
                        this.autoCompleteRef.current.parentElement.classList.remove('focused');
                       // lastFocusable.focus();
                    }

                    if (e.target === lastFocusable) {
                        //firstFocusable.focus();                       
                        lastFocusable.focus();
                       //this.autoCompleteRef.current.parentElement.classList.remove('focused');
                    }
                },

                40: () => { //down arrow
                    for(var i=0; i<focusable.length; i++) { //loop through each element
                        if(focusable[i].innerText == currentfocusedelement.innerText) { //check the current active element
                            focusable[i+1].focus();
                            e.preventDefault();
                            break;
                        }
                    }
                },

                38: () => { //UP arrow
                    for(var i=0; i<focusable.length; i++) { //loop through each element
                        if(focusable[i].innerText == currentfocusedelement.innerText) { //check the current active element
                            focusable[i-1].focus();
                            e.preventDefault();
                            break;
                        }
                    }
                },

                27:()=>{ //hide search items div on pressing escape key
                    this.autoCompleteRef.current.parentElement.classList.remove('focused');
                }
            };

            if (keys[e.keyCode]) {
                keys[e.keyCode]();
            }
        }
    }


    render() {
        return (
            <div className='searchcontglobal' tabIndex="-1">
                 <div   id="oneSearchContainer" ></div>
                 </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/modules/Search.js